/* ExerciseWindowConfigurationService / MaturityScheduleConfigurationService not available in production api-services build
import { DynamicTableV2 } from '@packages/table-builder';
import { Page } from '@packages/ui/layout';
import { axiosInstance } from '@/services/apiInterceptor';
import '@/apps/customer/domains/exercisability-instructions/exercisability-instructions.actions';
import { exercisabilityInstructionsTable } from './schema';
*/

export default function ExercisabilityInstructionsPage() {
  return null;
}
